/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-08-19 09:57:49
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-08-31 11:32:39
 */
import { Dropdown, Input, message, Menu, Progress } from 'antd'
import Avatar from 'antd/lib/avatar/avatar'

import React from 'react'
import { connect } from 'react-redux'
// import { ReceiveMesssgeEntity, User } from 'src/modules/localEntity'
import { checkfileexist } from '../service/filectrl'
// import { getDownloadPathLocal } from '../../../service/localstore'
// import { DeleteRoomUnReadMsg } from '../../../store/actionCreators'
import { customlog, standardSize, transformtimesimple } from '../../../../utils/tools'
import UserCenter from '../../UserCenter/index'
import axios from 'axios'
import { data } from 'jquery'

const cwindow = window
var fs = cwindow.fs;
const { Search, TextArea } = Input
const ipcRenderer = cwindow.electron ? cwindow.electron.ipcRenderer : null;
// interface Props {
//     /**登录用户 */
//     user: User,
//     /**消息发送用户 */
//     userinfo: User,
//     /**消息 实体  用户信息只包含userID*/
//     data: ReceiveMesssgeEntity,
// }
// *******   *********  ********* ******   *****************   *******
// *******   *********   *         *****  ************    **  ********
// ******     *********         *******            *****            **
// *****   *    *************   ******   ******************   ****  **
// ***    ****   ************   ******            ****  **   *****  **
// **              *                *   *************            *  **
// *   **********   **   ****   ***********************   *      *  **
// *******************   ****   ******            *********      *  **
// **              ***   *         ************   ******  *         **
// ******   **********   *   ***   ************   ******            **
// ******   *  *******       ***   ************   *****   *   ***  ***
// ****    *    ******       ***   ************     ***   *   ********
// ***   *****   *****   *         ************      *   **   ****   *
// **             *****  *   ***   *************    **   **          *
// ************  ************************************** **************
class MessageEntity extends React.Component {
    state = {
        avatar: '',
        my: false,
        message: <></>,
        // process: 0,
        // filesize: 0,
        // url: '',//不带名称参数的路径
        // path: '',
        // fileName: ''
    }
    componentWillMount() {

    }
    componentDidMount() {
        if (this.props.user.userId === this.props.data.userId) {
            this.setState({ my: true, avatar: this.props.user.avatar })
        } else if (this.props.userinfo) {
            this.setState({ avatar: this.props.userinfo.avatar })
        }
        // switch (this.props.data.type) {
        //     case "img":
        //         let filecontent = this.props.data.content
        //         let strUrl, fileName
        //         try {
        //             let filejson = JSON.parse(filecontent)
        //             strUrl = filejson.url
        //             fileName = filejson.fileName
        //         } catch (e) {
        //             strUrl = filecontent
        //             fileName = "未知文件"
        //         } 
        //         let path = getDownloadPathLocal() + '\\' + fileName
        //         let file = checkfileexist({ path })
        //         this.setState({ process: file.process, filesize: file.filesize, url: strUrl, path: path, fileName })
        //         // this.filelistener(strUrl)
        //         break;
        // }
    }


    canceldownload = () => {

    }
    render() {
        let message
        let { my } = this.state
        let { type, time, content } = this.props.data
        switch (type) {
            case 'text':
                message = <>
                    {content}
                </>
                break;
            case 'img':
                message = <MessageEntityImg data={this.props.data}></MessageEntityImg>
                break;
            case 'file':
                message = <MessageEntityFile data={this.props.data}></MessageEntityFile>
                break;
            case 'message':
                message = <>
                    {content}
                </>
                break;
            default:
                message = null
        }
        // console.log('bug',this.props.data,this.props.userinfo)
        return (
            <div style={{ width: '100%', float: 'left' }}>
                <div className={type === 'message' ? 'chat-message-system' : my ? 'chat-message-mine' : 'chat-message-other'}>
                    <Avatar size={36} shape="square" src={this.state.avatar} className={'chat-avatar'}></Avatar>
                    <div className='chat-message-panel'>
                        <div className="chat-message-name-warp">
                            <span className='chat-message-username'>
                                {this.props.userinfo.userName}
                            </span>
                            <span className='chat-message-time'>
                                {transformtimesimple(time)}
                            </span>
                        </div>
                        <div className={`chat-message-text${type === 'img' ? ' chat-message-img' : ''}`}>
                            {/* {this.props.data.text} */}
                            {message}
                        </div>
                    </div>
                </div>
            </div >);
    }
}


// interface PropsFile {
//     data: ReceiveMesssgeEntity
// }

export class MessageEntityFile extends React.Component {
    state = {
        avatar: '',
        my: false,
        message: <></>,
        process: 0,
        filesize: 0,
        url: '',//不带名称参数的路径
        path: '',
        fileName: ''
    }
    componentDidMount() {
        let filecontent = this.props.data.content
        let strUrl, fileName
        try {
            if (!filecontent.url) {
                let filejson = JSON.parse(filecontent)
                if (filejson.url) {
                    strUrl = filejson.url
                    fileName = filejson.fileName
                }
                else {
                    strUrl = filecontent
                    fileName = "未知文件"
                }
            }
            else {
                strUrl = filecontent.url;
                fileName = filecontent.fileName;
            }
        } catch (e) {
            console.log(e);
            strUrl = filecontent
            fileName = "未知文件"
        }
        // let strs =strUrl.split('/')
        // let name = strs[strs.length - 1]
        // let path = getDownloadPathLocal() + '\\' + name

        // let strUrl = this.props.data.content
        // let strs = this.props.data.content.split('/')
        // let name = strs[strs.length - 1]                

        // let path = getDownloadPathLocal() + '\\' + fileName
        // let file = checkfileexist({ path })
        // this.setState({ process: file.process, filesize: file.filesize, url: strUrl, path: path, fileName })
        this.setState({
            url: strUrl,
            fileName: fileName
        })
        // this.filelistener(this.state.url)
    }

    fileClick = (url) => {
        let { process, path, } = this.state
        if (this.state.process - 100 === 0) {
            // let strUrl = this.props.data.content
            // let strs = this.props.data.content.split('/')
            // let name = strs[strs.length - 1]
            // let path = getDownloadPathLocal() + '\\' + name
            fs.exists(path, exist => {
                if (exist)
                    ipcRenderer.send('file-open', path)
                else
                    message.error('文件已被删除或移动')
            });//如果文件已存在读取文件信息

        } else if (this.state.process === 0) {
            this.downloadfile()
        } else {
            // debugger
        }
    }
    openfloder = (path) => {
        fs.exists(path, exist => {
            if (exist)
                ipcRenderer.send('file-openfloder', path)
            else
                message.error('文件未下载或已被删除或移动')
        });//如果文件已存在读取文件信息
    }


    downloadfile = () => {
        let { process, url, path, fileName } = this.state
        let _this = this

        // window.open(url, 'download', 'status=0')

        // fetch(url, {
        //     method: 'get',
        //     credentials: 'include',
        //     mode: "no-cors",
        //     headers: new Headers({
        //         'Content-Type':'application/json'
        //     })
        // }).then((response) => {
        //     // console.log(response)
        //     response.blob().then(blob => {
        //         let blobUrl = window.URL.createObjectURL(blob)
        //         const aElement = document.createElement('a')
        //         document.body.appendChild(aElement)
        //         aElement.style.display = 'none'
        //         aElement.href = blobUrl
        //         aElement.download = fileName
        //         aElement.click()
        //         URL.revokeObjectURL(aElement.href)
        //         document.body.removeChild(aElement)

        //     })
        // }).catch(error => {
        //     console.log('文件下载失败',error)
        // })

        fetch(url, {
            method: 'get',
            credentials: 'include',
            mode: "no-cors",
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response) => {
            // console.log(response)
            return response.blob()
        }).then(blob => {
            const blobUrl = window.URL.createObjectURL(new Blob([blob]))
            const aElement = document.createElement('a')
            aElement.href = blobUrl
            aElement.setAttribute('download', fileName)
            aElement.style.display = 'none'
            document.body.appendChild(aElement);
            aElement.click()
            aElement.parentElement.removeChild(aElement)
            window.URL.revokeObjectURL(blobUrl)

        }).catch(error => {
            console.log('文件下载失败', error)
        })

        // axios({
        //     methods: 'get',
        //     url: url,
        //     responseType: 'blob',
        //     mode: "no-cors",
        //     contentType: "application/x-www-form-urlencoded",
        //     withCredentials: true,
        //     "Access-Control-Allow-Origin": "*",
        //     "Access-Control-Allow-Credentials":true
        // }).then(res => {
        //     if (!res) {
        //         return
        //     }
        //     let blobUrl = window.URL.createObjectURL(new Blob([res.data], { type: 'text/csv' }))
        //     console.log(res.data)
        //     console.log("header", res.headers, res.data.headers)
        //     let a = document.createElement('a')
        //     a.href = blobUrl
        //     let content = res.headers['content-disposition'].split(';')[1].split("UTF-8")[1].substr(2)
        //     console.log(content)
        //     let decode = decodeURI(content, 'UTF-8')
        //     console.log('decode', decode)
        //     a.setAttribute('download', decode)
        //     document.body.appendChild(a)
        //     a.click()
        //     URL.revokeObjectURL(a.href)
        //     document.body.removeChild(a)
        // })

    }
    // filelistener = (url) => {
    //     let _this = this
    //     ipcRenderer && ipcRenderer.on(url, ((sender, item, type) => {
    //         customlog('响应了 下载' + type + '事件，状态为' + item.state, '')
    //         console.log(item)
    //         let process
    //         if (item.state === 'interrupted') {
    //             process = -1

    //         } else {
    //             process = (item.offset / item.length * 100).toFixed(2)
    //         }
    //         _this.setState({ process: process, filesize: item.length })
    //     }))
    // }

    render() {
        let { process, url, path, fileName } = this.state
        const menu = (info) => <Menu>
            <Menu.Item key="1" onClick={this.openfloder.bind(this, path)}>{'在文件夹中显示'}</Menu.Item>
        </Menu>
        return (
            // <Dropdown overlay={menu.bind(this)} trigger={['contextMenu']}>
            <a id='a'

                href={url}
                target="_blank"
                // onClick={this.fileClick.bind(this, url)}
                download='iii'>
                <div className='chat-message-filemessage'
                // onClick={this.fileClick.bind(this, url)}
                >
                    <div className='chat-message-filemessage-icon'>
                        <img src={require('../img/icon_compass.png')}></img>
                    </div>
                    <div className='chat-message-filemessage-text'>
                        <div className='chat-message-filename'> {fileName}
                        </div>
                        {this.state.process === 0 ? <div className='chat-message-filesize'> {'点击打开'}</div>
                            : this.state.process - 100 === 0 ? <div className='chat-message-filesize'> {standardSize(this.state.filesize)}
                            </div>
                                : <Progress percent={this.state.process} className='chat-message-fileprocess' ></Progress>
                        }
                    </div>
                </div>
            </a>

            // </Dropdown>
        )
    }


}

// interface PropsImg {
//     data: ReceiveMesssgeEntity
// }

export class MessageEntityImg extends React.Component {
    state = {
        url: '',//不带名称参数的路径
    }
    componentDidMount() {
        let filecontent = this.props.data.content
        let strUrl, fileName
        try {
            if (!filecontent.url) {
                let filejson = JSON.parse(filecontent)
                console.log("MessageEntityImg----filejson", filejson);
                if (filejson.url) {
                    strUrl = filejson.url
                    fileName = filejson.fileName
                }
                else {
                    strUrl = filecontent
                    fileName = "未知图片"
                }
            }
            else {
                strUrl = filecontent.url;
                fileName = filecontent.fileName;
            }
        } catch (e) {
            console.log(e);
            strUrl = filecontent
            fileName = "未知图片"
        }
        // let path = getDownloadPathLocal() + '\\' + fileName
        // let file = checkfileexist({ path })
        this.setState({ url: strUrl })
        // this.filelistener(strUrl)
    }

    render() {
        let { url } = this.state

        return (
            <img style={{ maxWidth: '100%' }} src={url} />
        )
    }


}


// /**
//      * 获取页面文件名
//      * @param url 文件url
//      */
//  function downloadUrlFile(url) {
//     url = url.replace(/\\/g, '/');
//     const xhr = new XMLHttpRequest();
//     xhr.open('GET', url, true);
//     xhr.responseType = 'blob';
//     //xhr.setRequestHeader('Authorization', 'Basic a2VybWl0Omtlcm1pdA==');
//     xhr.onload = () => {
//         if (xhr.status === 200) {
//             // 获取文件blob数据并保存
//             var fileName = getFileName(url);
//             saveAs(xhr.response, fileName);
//         }
//     };

//     xhr.send();
// }

// /**
//  * URL方式保存文件到本地
//  * @param data 文件的blob数据
//  * @param name 文件名
//  */
// function saveAs(data, name) {
//     var urlObject = window.URL || window.webkitURL || window;
//     var export_blob = new Blob([data]);
//     var save_link = document.createElementNS( 'a')
//     save_link.href = urlObject.createObjectURL(export_blob);
//     save_link.download = name;
//     save_link.click();
// }

// /**
//  * 根据文件url获取文件名
//  * @param url 文件url
//  */
// function getFileName(url) {
//     var num = url.lastIndexOf('/') + 1
//     var fileName = url.substring(num)
//         //把参数和文件名分割开
//     fileName = decodeURI(fileName.split("?")[0]);
//     return fileName;
// }







// const mapState = state => ({
//     user: state.userReducer.get('user').toJS(),
//     messageList: state.messageReducer.get('messageList').toJS(),
//     usercacheList: state.cacheReducer.get('usercacheList').toJS(),
//     activeRoom: state.userReducer.get('activeRoom'),
// })
// const mapDispatch = dispatch => ({
//     // addRoomLastMsg(param) {
//     //     dispatch(AddRoomLastMsg(param))
//     // },
//     deleteRoomUnReadMsg(param) {
//         dispatch(DeleteRoomUnReadMsg(param))
//     }
// })

// export default connect(
//     mapState,
//     mapDispatch
// )(MessageEntity)
export default MessageEntity